import { Component } from 'utils/jsx'
import { writable } from 'utils/state'
import classnames from 'classnames'

export default class Button extends Component {
  beforeRender (props) {
    this.state = {
      compact: props['store-compact'] ? props['store-compact'] : writable(props.compact),
      hidden: props['store-hidden'] ? props['store-hidden'] : writable(props.hidden),
      disabled: props['store-disabled'] ? props['store-disabled'] : writable(props.disabled)
    }
  }

  template (props) {
    return (
      <button
        title={props.title}
        store-title={props['store-title']}
        class={classnames('button', props.class)}
        event-click={props['event-click']}
        store-disabled={this.state.disabled}
        store-hidden={this.state.hidden}
        store-class-is-compact={this.state.compact}
        style={props.style}
      >
        {props.icon && <span class='button__icon-wrapper'><i class={`fa fa-${props.icon}`} ref={this.ref('icon')}/></span>}
        {props.children.length > 0 && <span class='button__label' ref={this.ref('label')}>{props.children}</span>}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Button.js